module.exports = __webpack_public_path__ + "static/media/test8.7c5e811d.jpeg";